import React, { useEffect, useMemo, useState } from 'react';
import SupplierRedemptionTable from './SupplierRedemptionTable';
import axios from "axios";
import { connect } from "react-redux";

const SupplierRedemptionIndex = ({ organization }) => {
  const [merchants, setMerchants] = useState([]);
  const [isLoadingMerchants, setIsLoadingMerchants] = useState(true);
  const [merchantLoadError, setMerchantLoadError] = useState("");

  useEffect(() => {
    if (!organization?.id) {
      return undefined;
    }

    let isMounted = true;
    const merchantsApiUrl = `/organization/${organization.id}/merchant?page=0&limit=9999999999&minimal=1`;

    setIsLoadingMerchants(true);
    setMerchantLoadError("");
    setMerchants([]);

    axios.get(merchantsApiUrl)
      .then((response) => {
        if (isMounted) {
          setMerchants(response.data || []);
        }
      })
      .catch((error) => {
        if (isMounted) {
          setMerchantLoadError(error?.message || "Unable to load suppliers for this report.");
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoadingMerchants(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [organization?.id]);

  const merchantIds = useMemo(
    () => merchants.map((item) => item.id),
    [merchants]
  );

  if (isLoadingMerchants) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        Loading supplier redemption...
      </section>
    );
  }

  if (merchantLoadError) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        {merchantLoadError}
      </section>
    );
  }

  if (merchantIds.length === 0) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        No suppliers are available for this report.
      </section>
    );
  }

  return (
    <section className="manager-report-legacy">
      <SupplierRedemptionTable merchants={merchantIds} />
    </section>
  );
}

const mapStateToProps = (state) => {
  return {
    organization: state.organization,
  };
};
export default connect(mapStateToProps)(SupplierRedemptionIndex);
